export { normalizeTopLevelSpec as normalize } from '../normalize';
export function isUnitSpec(spec) {
  return !!spec['mark'];
}